<div class="container">

  <mat-tab-group [selectedIndex]="selected.value" (selectedTabChange)="back($event)">
    <mat-tab label="Historial combustible">
      <div style="width: 100%; margin-top: 30px;">
        <data-table [title]='titleFO' [columns]='columnasFO' [configuration]='configurationFO'
          [reloadTable]='recargarTablaFO' [params]='params' [url]='urlTableFO' (view)='viewDetail($event)'
          (edit)='editFO($event)' (print)='print($event)' [headerFilters]="headerFilters"
          [headerFileXlsm]="headerFileXlsm"></data-table>
      </div>


    </mat-tab>

    <mat-tab *ngIf="selected.value == 1" label="Detalle">
      <div class="containerCard">

        <mat-card style="background-color: #ffffff7a;">

          <h2><strong>Equipo: {{data.code}}</strong></h2>
          <h3>Fecha: {{data.date}}</h3>
          <h3>Solicita: {{data.requestsName}}</h3>
          <h3>Lugar: {{data.place}}</h3>
          <h3>Tipo de Combustible: {{data.fuelType}}</h3>
          <h3>Galones: {{data.gallons}}</h3>
          <h3>Precio Galón: {{data.gallonPrice | number:'1.0-0'}}</h3>
          <h3>Precio Total: {{data.totalPrice | number:'1.0-0'}}</h3>
          <h3>Número Factura: {{data.billNumber}}</h3>
          <h3>Orden Venta: {{data.salesOrder}}</h3>
          <h3>Descripción: {{data.description}}</h3>
          <h3>Odómetro/Horómetro: {{data.orderOdometer | number:'1.0-0'}}</h3>
          <hr>
          <h2>Autorizó: {{data.authorizeName}}</h2>

        </mat-card>

      </div>
    </mat-tab>
  </mat-tab-group>

</div>
